import React from 'react';

const SuggestedPrompts = ({ suggestions, onSelect }) => {
    if (!suggestions || suggestions.length === 0) return null;

    return (
        <div className="clarence-suggestions">
            <div className="suggestions-label">Suggested questions:</div>
            <div className="suggestions-list">
                {suggestions.map((suggestion, idx) => (
                    <button key={idx} className="suggestion-chip" onClick={() => onSelect(suggestion)}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>{suggestion}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SuggestedPrompts;
